import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = { class: "input-row" }
const _hoisted_3 = { class: "input-wr" }
const _hoisted_4 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_5 = { class: "input-wr" }
const _hoisted_6 = { class: "input-row" }
const _hoisted_7 = { class: "input-wr w-100" }
const _hoisted_8 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_9 = {
  key: 1,
  class: "error-hint"
}
const _hoisted_10 = { class: "input-row" }
const _hoisted_11 = { class: "input-wr" }
const _hoisted_12 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_13 = { class: "input-wr" }
const _hoisted_14 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_15 = { class: "input-row" }
const _hoisted_16 = { class: "input-wr w-100" }
const _hoisted_17 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_18 = {
  key: 1,
  class: "error-hint"
}
const _hoisted_19 = { class: "controls" }
const _hoisted_20 = {
  key: 1,
  class: "spinner-wr"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $props.isOpen,
    onClose: $setup.close
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[17] || (_cache[17] = _createElementVNode("div", { class: "modal-title" }, "Create Lead", -1)),
        _createElementVNode("form", {
          class: "default-form",
          onSubmit: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[10] || (_cache[10] = _createElementVNode("label", { class: "label" }, "First Name", -1)),
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["input", { error: $setup.v$.firstName.$error }]),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.firstName) = $event)),
                type: "text",
                placeholder: "First Name"
              }, null, 2), [
                [_vModelText, $setup.form.firstName]
              ]),
              ($setup.v$.firstName.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($setup.v$.firstName.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[11] || (_cache[11] = _createElementVNode("label", { class: "label" }, "Last Name", -1)),
              _withDirectives(_createElementVNode("input", {
                class: "input",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.lastName) = $event)),
                type: "text",
                placeholder: "Last Name"
              }, null, 512), [
                [_vModelText, $setup.form.lastName]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[12] || (_cache[12] = _createElementVNode("label", { class: "label" }, "Email", -1)),
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["input", { error: $setup.v$.email.$error || $setup.emailError }]),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.email) = $event)),
                type: "email",
                placeholder: "Email",
                onInput: _cache[3] || (_cache[3] = ($event: any) => ($setup.emailError = '')),
                onBlur: _cache[4] || (_cache[4] = ($event: any) => ($setup.v$.email.$touch()))
              }, null, 34), [
                [_vModelText, $setup.form.email]
              ]),
              ($setup.v$.email.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString($setup.v$.email.$errors[0].$message), 1))
                : ($setup.emailError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString($setup.emailError), 1))
                  : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _cache[13] || (_cache[13] = _createElementVNode("label", { class: "label" }, "Phone", -1)),
              _createVNode($setup["Cleave"], {
                class: _normalizeClass(["input", { error: $setup.v$.phone.$error }]),
                modelValue: $setup.form.phone,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.form.phone) = $event)),
                options: $setup.phoneNumberOption($setup.form.phone),
                placeholder: "0412 345 678"
              }, null, 8, ["modelValue", "options", "class"]),
              ($setup.v$.phone.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString($setup.v$.phone.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[14] || (_cache[14] = _createElementVNode("label", { class: "label" }, "Postcode", -1)),
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["input", { error: $setup.v$.postcode.$error }]),
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.form.postcode) = $event)),
                type: "text",
                maxlength: "4",
                placeholder: "e.g. 2000"
              }, null, 2), [
                [_vModelText, $setup.form.postcode]
              ]),
              ($setup.v$.postcode.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString($setup.v$.postcode.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _cache[15] || (_cache[15] = _createElementVNode("label", { class: "label" }, "Notes", -1)),
              _withDirectives(_createElementVNode("textarea", {
                class: _normalizeClass(["input textarea", { 'input--error': $setup.v$.notes.$error }]),
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.form.notes) = $event)),
                placeholder: "Notes"
              }, null, 2), [
                [_vModelText, $setup.form.notes]
              ]),
              ($setup.v$.notes.minLength.$invalid)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString($setup.v$.notes.minLength.$message), 1))
                : ($setup.v$.notes.maxLength.$invalid)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString($setup.v$.notes.maxLength.$message), 1))
                  : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("button", {
              class: "button default cancel",
              onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.close(false)))
            }, "Cancel"),
            (!$setup.loading)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "button default primary release",
                  onClick: $setup.save
                }, "Save"))
              : (_openBlock(), _createElementBlock("div", _hoisted_20, [...(_cache[16] || (_cache[16] = [
                  _createElementVNode("div", { class: "spinner spinner-small" }, null, -1)
                ]))]))
          ])
        ], 32)
      ])
    ]),
    _: 1
  }, 8, ["isOpen"]))
}